import { Component , Prop , Watch , Mixins} from 'vue-property-decorator';
import { IEdTabsMenu } from '@/content/interfaces/ed-tabs-menu.interface';
import { SECTION_TYPES } from '@/content/values/sections';
import { HOMEWORK_STATUS } from '@/homework/values/homeworks.values';
import { Section } from '@/courses/models/section.model';
import { _APP_STORE } from '@/core/values/app.values';
import { FOOTER_TYPE } from '@/core/values/core.values';
import KEYS from '@/values/keys';
import { CourseToolsMixin } from './course-tools.mixin';
import Course from '@/content/models/course.model';
import { MEETING_EVENTS } from '@/meetings/values/meetings.values';

@Component({})
export class CourseViewerSplitObjectMixin extends Mixins(CourseToolsMixin) {

  /* Props */
  @Prop() readonly section: Section;
  @Prop() readonly courseId: number;

  /* Data */
  public menu: IEdTabsMenu[] = null;
  public problem: Section = null;
  public solution: Section = null;
  public answer: Section = null;
  public menuSplitFirst: IEdTabsMenu[];
  public menuSplitSecond: IEdTabsMenu[];
  public isFullScreen: boolean = false;
  public tabSelected: string = '';
  public contentsId: any = {
    problem: 'ProblemTab',
    response: 'ResponseTab',
    answer: 'AnswerTab',
    solution: 'SolutionTab',
    splitHorizontal: 'SplitHorizontal',
    splitVertical: 'SplitVertical',
  };

  /* Computed */
  get isTeacher(): boolean {
    return this.$store.state.AuthStore.role !== KEYS.ROLES.BUYER;
  }

  get hasAnswer(): boolean {
    return this.answer ? true : false;
  }

  get oneviewSelected(): boolean {
    switch(this.tabSelected) {
      case this.contentsId.problem:
      case this.contentsId.response:
        return true;
      break;
    }
    if(this.isTeacher) {
      switch(this.tabSelected) {
        case this.contentsId.solution:
        case this.contentsId.answer:
          return true;
        break;
      }
    }
    return false;
  }

  get isHorizontalViewSelected() {
    let splitHorizontal = this.tabSelected ? (this.tabSelected == this.contentsId.splitHorizontal) : false;
    this.$Courses.Store.isSplitHorizontal(splitHorizontal);
    splitHorizontal && this.$Courses.Store.setZoomObject(true);
    return splitHorizontal;
  }

  get isVerticalViewSelected() {
    let splitVertical = this.tabSelected ? (this.tabSelected == this.contentsId.splitVertical) : false;
    this.$Courses.Store.isSplitVertical(splitVertical);
    splitVertical && this.$Courses.Store.setZoomObject(true);
    return splitVertical;
  }

  get problemUrl(): string {
    return this.problem.assetsInfo[0].url;
  }

  get solutionUrl(): string {
    return this.solution ? this.solution.assetsInfo[0].url : null;
  }

  get isProblemFile(): boolean {    
    return this.problem.sectionMaterial ? false : true;
  }

  get isSolutionFile(): boolean {
    return this.solution ? this.solution.sectionMaterial ? false : true : true;
  }

  get problemMaterial(): any {    
    if(!this.course && this.problem.sectionMaterial && this.$store.state.CourseStore.isPresentationStudentMode){
      let sectionMaterial = this.problem.sectionMaterial;
      sectionMaterial.data = {...sectionMaterial.materialAssetInfo};      
      return sectionMaterial;
    }
    let mat = this.problem.sectionMaterial;
    return !this.isProblemFile && mat ? mat : null;
  }

  get solutionMaterial(): any {
    if(this.solution) {
      let mat = this.solution.sectionMaterial;
      return !this.isSolutionFile && mat ? mat : null;
    } else {
      return null;
    }
  }
  
  get viewerProblem() {
    let viewer:any = SECTION_TYPES.LESSON_PDF.viewer;
    if( this.problemMaterial ) {
      viewer = this.setCourseMaterialViewer(this.problemMaterial);
    }
    return viewer;
  }

  get viewerSolution() {
    let viewer:any = SECTION_TYPES.LESSON_PDF.viewer;
    if( this.solutionMaterial ) {
      viewer = this.setCourseMaterialViewer(this.solutionMaterial);
    }
    return viewer;
  }

  get response(): Section {
    if(this.section.homeworkInfo) {
      switch(this.section.homeworkStatus) {
        case HOMEWORK_STATUS.FINISHED:
        case HOMEWORK_STATUS.GRADED:
        case HOMEWORK_STATUS.FEEDBACK_DRAFT:
        case HOMEWORK_STATUS.NEW: 
        case HOMEWORK_STATUS.SEEN: 
          return {
            ...this.section.homeworkInfo,
            assetsInfo: [this.section.homeworkInfo.homeworkAssetInfo] 
          };
        break; 
      }
    }
    return null;
  }

  get course(): Course {
    return this.getCourseFromStore({courseId: this.section.courseId , classId: this.section.classId});
  }

  get isPresentationMode() : boolean{
    return this.$store.state.CourseStore.isPresentationStudentMode || this.$store.state.CourseStore.isPresentationTeacherMode;
  }

  setMenu(response, hasAnswer: boolean = false) {
    this.menu = [{
     name: String(this.$i18n.t('courses.writeObject.problemTab')),
     contentId: this.contentsId.problem,
     active: true,
     visible: true
   }];
   if(this.isTeacher) {
    this.setTeacherMenu(hasAnswer, response);
   } else {
     if(response) {
       this.menu.push({
         name: String(this.$i18n.t('courses.writeObject.responseTab')),
         contentId: this.contentsId.response,
         active: false,
         visible: true
       });
     } else if(this.answer) {
       this.menu.push({
         name: String(this.$i18n.t('courses.writeObject.responseTab')),
         contentId: this.contentsId.answer,
         active: false,
         visible: true
       });
     }
   }
  }

  setTeacherMenu(hasAnswer: boolean = false, response) {

    if((hasAnswer && !this.isPresentationMode) || (hasAnswer && !response && this.isPresentationMode)) {
      this.menu.push({
        name: String(this.$i18n.t('courses.writeObject.responseTab')),
        contentId: this.contentsId.answer,
        active: false,
        visible: true
      });
    }

    if(response && this.isPresentationMode) {      
      this.menu.push({
        name: String(this.$i18n.t('courses.writeObject.responseTab')),
        contentId: this.contentsId.response,
        active: false,
        visible: true
      });
    }

     if(this.solution) {
       this.menu.push({
         name: String(this.$i18n.t('courses.writeObject.solutionTab')),
         contentId: this.contentsId.solution,
         active: false,
         visible: true
       });
     }
  }

  settingTab(tabParams: any) {
    if(this.tabSelected !== tabParams.contentId) {
      switch(tabParams.contentId) {
        case this.contentsId.splitVertical:
          this.setPositionTabs('Vertical' , tabParams.response );
          this.menu.forEach(m => m.visible = false);
        break;
        case this.contentsId.splitHorizontal:
          this.setPositionTabs('Horizontal' , tabParams.response);
          this.menu.forEach(m => m.visible = false);
        break;
        default:
          this.menu.forEach(m => {
            m.visible = (m.contentId !== this.contentsId.splitVertical && m.contentId !== this.contentsId.splitHorizontal);
            m.active = m.contentId == tabParams.contentId;
          });
          this.onChangeTab({contentId:tabParams.contentId, name:null, active:null, visible:null});
        break;
      }
      tabParams.el.setTab(tabParams.contentId);
      this.tabSelected = tabParams.contentId;
    }
  }

  setPositionTabs(position: string , responseParam) {
    let problem: any = document.getElementById('Problem');
    let solution: any = document.getElementById('Solution');
    let response: any = document.getElementById('Response');
    let answer: any = document.getElementById('Answer');
    let problemPosition = document.getElementById(`ProblemTab${position}`);
    let solutionPosition = document.getElementById(`SolutionTab${position}`);
    let responsePosition = document.getElementById(`ResponseTab${position}`);
    let answerPosition = document.getElementById(`AnswerTab${position}`);    
   
    problemPosition?.appendChild(problem);
    if(this.isTeacher) solutionPosition?.appendChild(solution);
    if((!this.isTeacher || this.isPresentationMode) && responseParam) responsePosition?.appendChild(response);
    if(answer) answerPosition?.appendChild(answer);
  }

  setFirstTabItem(itemName: string) {
    let item: any = document.getElementById(itemName);
    let itemContainer = document.getElementById(`${itemName}Container`);
    itemContainer?.appendChild(item);
  }

  setFiles() {
    this.setAnswer();
    this.section.sections.forEach((s) => {
      this.problem  = (s.type == SECTION_TYPES.SPLIT_QUESTION_PDF.code) ? s : this.problem;
      this.problem  = (s.type == SECTION_TYPES.SPLIT_QUESTION_MATERIAL.code) ? this.getCourseMaterialSection(s) : this.problem;
      this.solution = (s.type == SECTION_TYPES.SPLIT_SOLUTION_PDF.code) ? s : this.solution;
      this.solution  = (s.type == SECTION_TYPES.SPLIT_SOLUTION_MATERIAL.code) ? this.getCourseMaterialSection(s) : this.solution;
    });
  }

  getCourseMaterialSection(section: Section): Section {
    return {
      ...section,
      text: section.sectionMaterial.materialAssetInfo.hash,
      type: SECTION_TYPES.LESSON_MATERIAL.code,
    };
  }

  setAnswer() {
    if(this.section.assetsInfo) {
      this.answer = new Section({
        sectionId: this.section.sectionId,
        type: SECTION_TYPES.LESSON_PDF.code,
        assetsInfo: this.section.assetsInfo,
        text: this.section.text,
        name: this.section.name,
        courseId: this.section.courseId
      });
    }
  }

  onChangeTab(tab: IEdTabsMenu) {
    this.$App.Store.changeFooterType(FOOTER_TYPE.NONE);
    switch(tab.contentId) {
      case this.contentsId.answer:
        if(!this.answer) this.$App.Store.changeFooterType(FOOTER_TYPE.COMPACT);
        this.setFirstTabItem('Answer');
      break;
      case this.contentsId.problem:
        this.setFirstTabItem('Problem');
      break;
      case this.contentsId.solution:
        if(!this.solution) this.$App.Store.changeFooterType(FOOTER_TYPE.COMPACT);
        this.setFirstTabItem('Solution');
      break;
      case this.contentsId.response:
        this.setFirstTabItem('Response');
      break;
    }
    this.tabSelected = tab.contentId;
    this.$edEventBus.$emit(MEETING_EVENTS.CHANGE_SPLIT_TAB);
  }

  setMenuSplit(response: any) {
    this.menuSplitFirst = this.getFirstSplitMenu();
    this.menuSplitSecond = this.getSecondSplitMenu(response);
  }

  getFirstSplitMenu() {
    let menu = [{
      name: String(this.$i18n.t('courses.writeObject.problemTab')),
      contentId: this.contentsId.problem,
      active: true,
      visible: true
    }];
    if(this.isTeacher && this.solution) {
      menu.push({
        name: String(this.$i18n.t('courses.writeObject.solutionTab')),
        contentId: this.contentsId.solution,
        active: false,
        visible: true
      });
    }
    return menu;
  }

  getSecondSplitMenu(response: any) {    
    if(this.isTeacher) {
      return [{
        name: String(this.$i18n.t('courses.writeObject.responseTab')),
        contentId: this.isPresentationMode && response ? this.contentsId.response : this.contentsId.answer,
        active: true,
        visible: true
      }];
    } else if(response) {
      return [{
        name: String(this.$i18n.t('courses.writeObject.responseTab')),
        contentId: this.contentsId.response,
        active: true,
        visible: true
      }];
    } else if(this.answer) {
      return [{
        name: String(this.$i18n.t('courses.writeObject.responseTab')),
        contentId: this.contentsId.answer,
        active: true,
        visible: true
      }];
    }
    return [];
  }

  /* Watchers */
  @Watch('section', { immediate: false, deep: true })
  sectionChanged() {
    this.setFiles();
  }

}